import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useAuthentication } from '@aviv-unified-frontend/runtime/authentication';
import { Box } from '@gemini/core';
import Container from '@/components/structure/Container';
import { useOfferSelection, usePushCards, useShortBrand, } from '@/contexts/brandConfiguration/hooks';
import { useTranslation } from '@/hooks/useTranslations';
import { trackPushCardRedirection } from '@/tracking/index';
import { signinRedirect } from '@/utils/signinRedirect';
import { Card } from './Card';
export const PushCards = ({ pageConfiguration, landingType, }) => {
    var _a;
    const { t } = useTranslation();
    const items = usePushCards(pageConfiguration, landingType);
    const { state } = useAuthentication();
    const shortBrand = useShortBrand();
    const isOfferSelectionDisplayed = (_a = useOfferSelection(pageConfiguration, landingType)) === null || _a === void 0 ? void 0 : _a.isOfferSelectionDisplayed;
    const cards = items === null || items === void 0 ? void 0 : items.map((item, index) => {
        return {
            img: item.img,
            alt: t(`fsrbo.generic.pushcards.list.item${index + 1}.img.alt`),
            title: t(`fsrbo.generic.pushcards.list.item${index + 1}.title`),
            description: t(`fsrbo.generic.pushcards.list.item${index + 1}.text`),
            link: {
                url: item.url,
                label: t(`fsrbo.generic.pushcards.list.item${index + 1}.button`),
            },
            onPress: (e) => {
                trackPushCardRedirection(e, index + 1);
                if (shortBrand == 'IWT' && state !== 'authenticated' && index === 1) {
                    signinRedirect({ e });
                }
            },
        };
    });
    return (_jsx(Box, { backgroundColor: "color.background.subdued", marginTop: isOfferSelectionDisplayed
            ? 'spacing.none'
            : {
                'breakpoint.base': 'spacing.32',
                'breakpoint.lg': 'spacing.80',
            }, children: _jsx(Container, { paddingVertical: {
                'breakpoint.base': 'spacing.32',
                'breakpoint.lg': 'spacing.80',
            }, noPaddingMobile: true, noPaddingTablet: true, noContainerTablet: true, children: _jsx(Box, { display: "flex", justifyContent: "space-between", gap: "spacing.16", overflowX: {
                    'breakpoint.base': 'scroll',
                    'breakpoint.xl': 'visible',
                }, paddingHorizontal: {
                    'breakpoint.base': 'spacing.16',
                    'breakpoint.xl': 'spacing.none',
                }, children: cards === null || cards === void 0 ? void 0 : cards.map((card) => _jsx(Card, { card: card }, card.title)) }) }) }));
};
